import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import FixedHeightWrapper from "app/meets/FixedHeightWrapper";

const NotFound = () => {
  const { meetId } = useParams<{ meetId: string }>();
  const [isArchived, setIsArchived] = useState(false);

  useEffect(() => {
    if (!meetId) return;

    const checkArchive = async () => {
      try {
        const response = await fetch(
          `https://couchdb.archive.liftingcast.com/${meetId}_readonly`,
        );

        if (response.ok) {
          setIsArchived(true);
          setTimeout(() => {
            window.location.href = `https://archive.liftingcast.com/meets/${meetId}`;
          }, 5000);
        }
      } catch (error) {
        console.error("Error checking archive:", error);
      }
    };

    checkArchive();
  }, [meetId]);

  if (isArchived) {
    return (
      <FixedHeightWrapper>
        <div className="not-found">Redirecting to archive...</div>
      </FixedHeightWrapper>
    );
  }

  return (
    <FixedHeightWrapper>
      <div className="not-found">
        This meet was not found.&nbsp;<Link to="/">Go Home</Link>
      </div>
    </FixedHeightWrapper>
  );
};

export default NotFound;
